<div class="add-to-talent-pool">
  <div
    class="wrapper-text"
    (click)="openModal()"
  >
    <mat-icon class="add-to-talent-pool-icon">add
    </mat-icon>
    Add to pool
  </div>
</div>

<div
  class="infinite-scroll-container"
  infiniteScroll
  *ngIf="{talentPoolsPageNumber: talentPoolsPageNumber$ | async, talentPools: talentPools$ | async, talentPoolsTotalPagesNumber: talentPoolsTotalPagesNumber$ | async} as state"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="1000"
  (scrolled)="onScroll(state.talentPoolsPageNumber, state.talentPoolsTotalPagesNumber)"
  [scrollWindow]="false"
>
  <mojo-talent-pools-item
    *ngFor="let talentPool of state.talentPools"
    [talentPool]="talentPool"
  ></mojo-talent-pools-item>
</div>
